module.exports = __webpack_public_path__ + "static/media/0_2019_11_09.3ccf8279.jpg";